import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';

export const mapResultDecisionAgreementStatusToLabel: Record<KnmResultDecisionAgreementStatusEnum, string> = {
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_DRAFT]: 'Черновик соглашения',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_CANCELED]: 'Отказано в соглашении',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_READY_TO_APPROVE]: 'Соглашение готово к согласованию',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_ON_APPROVAL]: 'Соглашение на согласовании',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_DENIED]: 'Соглашение не согласовано',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_APPROVED]: 'Соглашение утверждено',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_NOT_COMPLETED_WAITING_TERMINATION]:
    'Соглашение не исполнено. Ожидает расторжения',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_TERMINATED]: 'Соглашение расторгнуто',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_COMPLETED]: 'Соглашение исполнено',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_NOT_COMPLETED]: 'Соглашение не исполнено',
};
